export default "__VITE_ASSET__CoXfPbJO__"